/**
 * Moved to `@sizzlenz/shared-frontend/hooks`.
 * Re-exported here so existing `@/lib/hooks/useViewportHeightVars` imports keep working.
 */
export { useViewportHeightVars } from '@sizzlenz/shared-frontend/hooks';
